module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "margin": "80px 0 0 30px"
    }
  }, [(!_vm.errors) ? _c('div', {
    staticClass: "onestepcheckout-place-order-loading",
    staticStyle: {
      "display": "block"
    }
  }, [_c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/opc-ajax-loader.gif"
    }
  }), _vm._v("  \n            Please wait, processing your order...\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errors) ? _c('div', {
    staticStyle: {
      "padding": "1.6rem"
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n                错误： " + _vm._s(_vm.errors) + "\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "3.6rem"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "210px",
      "height": "30px",
      "border-radius": "15px",
      "background-color": "#FE6714",
      "border": "0px #FE6714 solid",
      "cursor": "pointer",
      "color": "white",
      "font-size": "16px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.callpay()
      }
    }
  }, [_vm._v("重新支付")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8cb70cf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/payment/wxpay/h5/Review.vue
// module id = 263
// module chunks = 1